module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-ties.2411fe73.png";